/**
 * Chrome tenant for platform routes (`/`, `/shops`, `/account`, …).
 * V2 — URL tenant only; identity is global when session is present.
 */

export const PLATFORM_CHROME_TENANT_CODE = '__platform__';

export function isPlatformChromeTenant(tenantCode: string): boolean {
  return tenantCode === PLATFORM_CHROME_TENANT_CODE;
}

/**
 * Hierarchical platform retail paths — prefix match (not exact-only).
 */
export function isPlatformRetailPath(pathname: string): boolean {
  return (
    pathname === '/' ||
    pathname === '/orgs' ||
    pathname.startsWith('/orgs/') ||
    pathname === '/browse' ||
    pathname.startsWith('/browse/') ||
    pathname === '/shops' ||
    pathname.startsWith('/shops/') ||
    pathname === '/favorites' ||
    pathname.startsWith('/favorites/') ||
    pathname === '/scan' ||
    pathname.startsWith('/scan/') ||
    pathname === '/receipt-recovery' ||
    pathname.startsWith('/receipt-recovery/') ||
    pathname === '/account' ||
    pathname.startsWith('/account/') ||
    pathname === '/more' ||
    pathname.startsWith('/more/') ||
    pathname === '/orders/find' ||
    pathname.startsWith('/orders/find/') ||
    pathname === '/help' ||
    pathname.startsWith('/help/') ||
    pathname === '/sign-in' ||
    pathname.startsWith('/sign-in/') ||
    pathname === '/sign-up' ||
    pathname.startsWith('/sign-up/') ||
    pathname === '/forgot-password' ||
    pathname.startsWith('/forgot-password/') ||
    pathname === '/reset-password' ||
    pathname.startsWith('/reset-password/') ||
    pathname === '/confirm-email' ||
    pathname.startsWith('/confirm-email/') ||
    pathname === '/onboarding/set-credentials' ||
    pathname.startsWith('/onboarding/set-credentials/') ||
    pathname === '/login' ||
    pathname.startsWith('/login/')
  );
}

/** @deprecated V2 — platform chrome sentinel only. */
export function resolvePlatformChromeTenantCode(): string {
  return PLATFORM_CHROME_TENANT_CODE;
}
